<div *ngIf="field.eavAttributeOption.length >0 &&field.frontendLabel!='Product'">
  <mat-form-field fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{frontEndLabel}}</mat-label>
    <mat-select [disableOptionCentering]="true" [formControlName]="field.attributeCode" #singleSelect>
      <mat-option>
        <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="fieldFilterControl"
          placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let item of fieldTypeList" [value]="item.optionId">
        {{item.eavAttributeOptionValue[0]?.value}}</mat-option>

    </mat-select>
    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>
  </mat-form-field>
</div>


<ng-container *ngIf="field.frontendLabel=='Product'">

  <div fxFle fxLayout="column">
    <mat-form-field fxFlex [formGroup]="group" appearance="outline">
      <mat-label>{{frontEndLabel}}</mat-label>
      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
            true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">

        <mat-option (onSelectionChange)="setPriceSelection($event,opt.entityId)" *ngFor="let opt of productList"
          [value]="opt.entityId">
          {{ opt.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex [formGroup]="group" appearance="outline">
      <mat-label>Product Price</mat-label>
      <input [attr.guide]="'select-lead-form-inp-1-1' + '__' + sanitizeUrl(url)" [autocomplete]="'off'" trim="blur" readonly matInput [formControl]="priceControl"/>

    </mat-form-field>


  </div>





</ng-container>

<div *ngIf="field.eavAttributeOption.length == 0&&field.frontendLabel!='Owner'&&field.frontendLabel!='Product'">
  <mat-form-field fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{frontEndLabel}}</mat-label>
    <ng-container *ngIf="field.frontendLabel!='Country of Manufacture'
       && field.frontendLabel!='sizeChart' && field.frontendLabel!='Deals Status'
       && field.frontendLabel!='Tax Class' && field.frontendLabel!='Apply MAP'&& field.frontendLabel!='Supplier'&& field.frontendLabel!='Lead Source'&&
        field.frontendLabel!='Lead Status'&& field.frontendLabel!='Country'&&field.frontendLabel!='Owner'&&field.frontendLabel!='Layout'&&field.frontendLabel!='Lecture'&&
        field.frontendLabel!='Doctor'&& field.frontendLabel!='Doctors' &&field.frontendLabel!='Category' &&field.frontendLabel!='Form'&&field.frontendLabel!='Priority'
         &&field.frontendLabel!='Tracker' &&field.frontendLabel!='Project' &&field.frontendLabel!='Status'">
      <mat-select [disableOptionCentering]="true" [formControlName]="field.attributeCode">
        <mat-option *ngFor="let item of Option" [value]="item.regionId">{{item.defaultName}}</mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Country of Manufacture'">
      <mat-select [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="countryFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredcountryTypeList" [value]="opt.countryName">
          {{opt.countryName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Country'">
      <mat-select [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="countryFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredcountryTypeList" [value]="opt.countryName">
          {{opt.countryName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Tax Class'">
      <mat-select [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="taxclassFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredTaxClassList" [value]="opt.classId">
          {{opt.className}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Supplier'">

      <mat-select [disabled]="supDisabled" [required]="group.controls[field.attributeCode].status == 'INVALID' ?
         true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="supplierFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredsupplierTypeList" [value]="opt.id">
          {{opt.company}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Lecture'">
      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
         true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="lectureFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredlectureTypeList" [value]="opt.id">
          {{opt.company}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Doctor'">
      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
         true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="doctorFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredDoctorTypeList" [value]="opt.id">
          {{opt.company}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Doctors'">
      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
         true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="doctorFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredDoctorTypeList" [value]="opt.id">
          {{opt.company}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Form'">
      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
         true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="dynamicFormFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filtereddynamicFormTypeList" [value]="opt.formGroupId">
          {{opt.name}}
        </mat-option>
      </mat-select>
    </ng-container>


    <ng-container *ngIf="field.frontendLabel=='Priority'">
      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
         true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="PriorityFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredPriorityTypeList" [value]="opt.priorityId">
          {{opt.priorityName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Tracker'">
      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
         true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="trackerFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredTrackerTypeList" [value]="opt.trackerId">
          {{opt.trackerName}}
        </mat-option>
      </mat-select>
    </ng-container>
    <ng-container *ngIf="field.frontendLabel=='Project'">
      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
         true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="projectsFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredprojectsTypeList" [value]="opt.id">
          {{opt.name}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Category'">

      <mat-select [required]="group.controls[field.attributeCode].status == 'INVALID' ?
        true : false" [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="categoryFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredCategoryTypeList" [value]="opt.categoryId">
          {{ opt.categoryName }}
        </mat-option>
      </mat-select>
    </ng-container>





    <ng-container *ngIf="field.frontendLabel=='Layout'">

      <mat-select [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="cmsFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredCmsTypeList;" [value]="opt.title">
          {{opt.title}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='sizeChart'">
      <mat-select [formControlName]="field.attributeCode">
        <mat-option *ngFor="let item of sizeChart" [value]="item.sizeId">
          {{item.sizeChartName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Apply MAP'">
      <mat-select [formControlName]="field.attributeCode">
        <mat-option *ngFor="let items of booleanField" [value]="items.value">
          {{items.viewValue}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Lead Source'">
      <mat-select [disableOptionCentering]="true" #singleSelect [formControlName]="field.attributeCode">
        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="leadSourceFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filteredleadSourceTypeList" [value]="opt.sourceId">
          {{opt.sourceName}}
        </mat-option>
      </mat-select>

      <!-- <mat-select  [formControlName]="field.attributeCode">
          <mat-option *ngFor="let lead of leadList" [value]="lead.sourceId">
            {{lead.sourceName}}
          </mat-option>
        </mat-select> -->
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Lead Status'">
      <mat-select [formControlName]="field.attributeCode">

        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="leadStatusFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
          *ngFor="let opt of filteredleadStatusTypeList" [value]="opt.statusId">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>

    <ng-container *ngIf="field.frontendLabel=='Status'">
      <mat-select [formControlName]="field.attributeCode">

        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="leadStatusFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
          *ngFor="let opt of filteredleadStatusTypeList" [value]="opt.statusName">
          {{opt.statusName}}
        </mat-option>
      </mat-select>
    </ng-container>


    <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
    </div>


  </mat-form-field>

</div>


<ng-container>

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

    <div *ngIf="init" fxFlex="60">

      <simple-dynamic-form [layout]="1" [formValue]="group.value" [status]="group.value.LeadStatus" [type]="newType"
        (submit)="onFormSubmitted($event)" [fields]="regConfig">

      </simple-dynamic-form>

    </div>

  </div>
</ng-container>

<ng-container *ngIf="field.frontendLabel=='Owner'&&!display">
  <mat-form-field fxFlex [formGroup]="group" appearance="outline">
    <mat-label>{{frontEndLabel}}</mat-label>
    <ng-container>
      <mat-select [formControlName]="field.attributeCode">

        <mat-option>
          <ngx-mat-select-search name="field.frontendLabel" ngDefaultControl [formControl]="userOwnerFilterControl"
            placeholderLabel="Search" [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.email">
          {{opt.email}}
        </mat-option>
      </mat-select>
    </ng-container>
  </mat-form-field>
</ng-container>